import { Skeleton, Stack } from "@mui/material";
import styles from "./InterviewUnattendedPage.module.css";

export default function UnattendedPageSkeleton() {
	return (
		<div className={styles.wrapper}>
			<Stack>
				<Skeleton height="32px" width="200px" />
				<Skeleton height="24px" width="300px" />
			</Stack>

			<Skeleton variant="rectangular" height="70px" />

			<Skeleton variant="rectangular" height="70px" />

			<div className={styles.nextSteps}>
				<Skeleton variant="circular" width="84px" height="84px" />
				<Skeleton width="150px" height="24px" />
				<Skeleton height="20px" width="100%" />
				<Skeleton variant="rectangular" height="35px" width="183px" />
			</div>
		</div>
	);
}
